// Report status values
export enum ReportStatus {
  DRAFT = 'draft',
  FINALIZED = 'finalized'
}
